var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25602_106089)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99935 0.667969C3.94935 0.667969 0.666016 3.9513 0.666016 8.0013C0.666016 12.0513 3.94935 15.3346 7.99935 15.3346C12.0493 15.3346 15.3327 12.0513 15.3327 8.0013C15.3327 3.9513 12.0493 0.667969 7.99935 0.667969ZM11.178 6.7613C11.2365 6.6944 11.2811 6.61646 11.3091 6.53208C11.337 6.4477 11.3478 6.35858 11.3409 6.26996C11.3339 6.18134 11.3092 6.09501 11.2684 6.01605C11.2276 5.9371 11.1713 5.86711 11.103 5.8102C11.0348 5.75329 10.9558 5.71061 10.8707 5.68468C10.7857 5.65874 10.6964 5.65008 10.6079 5.65919C10.5195 5.6683 10.4338 5.695 10.3558 5.73772C10.2779 5.78045 10.2093 5.83833 10.154 5.90797L7.28735 9.3473L5.80402 7.8633C5.67828 7.74186 5.50988 7.67467 5.33508 7.67619C5.16028 7.67771 4.99308 7.74782 4.86947 7.87142C4.74586 7.99503 4.67575 8.16224 4.67423 8.33704C4.67271 8.51183 4.73991 8.68023 4.86135 8.80597L6.86135 10.806C6.92685 10.8714 7.00528 10.9225 7.09163 10.956C7.17797 10.9895 7.27035 11.0046 7.36286 11.0004C7.45538 10.9962 7.546 10.9728 7.62896 10.9316C7.71191 10.8904 7.78538 10.8324 7.84468 10.7613L11.178 6.7613Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25602_106089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.9fd083c07f4dd3da8d57dc7fdb843e0c.svg";
export { ForwardRef as ReactComponent };